import "./Training.module.css";
import Header from "@/reusable_sections/Header";
import Training from "./sections/Training";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function TrainingPage() {
  return <div>
      <Header />
      <Training />
      <CallToAction />
      <Footer />
    </div>;
}